import React from 'react';
import { Box, Chip, Stack, TextField, Typography } from '@mui/material';
import { Code } from 'dashboard/components/common';

/**
 * Step 2 — chain picker + optional max-supply cap.
 *
 * Chains without an RPC configured are shown but not selectable.
 * Marketplace-not-configured chains are pickable but the chip warns
 * that listing flows will be limited.
 */
export default function StepChain({ form, setField, chains }) {
  return (
    <Stack spacing='12px'>
      <Typography variant='body2' fontWeight='600'>Chain *</Typography>
      {chains.length === 0 ? (
        <Typography variant='body2' color='text.secondary'>
          No chains are configured on the platform yet. Set <Code>marketplace.chains</Code> in the backend config.
        </Typography>
      ) : (
        <Stack spacing='6px'>
          {chains.map((c) => {
            const active = Number(form.chain_id) === c.chain_id;
            return (
              <Box
                key={c.chain_id}
                sx={{
                  p: '10px', borderRadius: '10px',
                  border: '1px solid',
                  borderColor: active ? 'primary.main' : 'divider',
                  cursor: c.rpc_configured ? 'pointer' : 'not-allowed',
                  opacity: c.rpc_configured ? 1 : 0.5,
                }}
                onClick={() => {
                  if (!c.rpc_configured) return;
                  setField('chain_id', String(c.chain_id));
                  setField('network_name', c.name);
                }}
              >
                <Stack direction='row' justifyContent='space-between' alignItems='center' flexWrap='wrap'>
                  <Box>
                    <Typography variant='body2' fontWeight='600'>{c.name}</Typography>
                    <Typography variant='caption' color='text.secondary'>
                      Chain ID {c.chain_id}
                    </Typography>
                  </Box>
                  {!c.rpc_configured && <Chip size='small' label='No RPC' />}
                  {c.rpc_configured && !c.marketplace_configured && (
                    <Chip size='small' color='warning' label='No marketplace' />
                  )}
                  {c.rpc_configured && c.marketplace_configured && (
                    <Chip size='small' color='success' label='Ready' />
                  )}
                </Stack>
              </Box>
            );
          })}
        </Stack>
      )}
      <TextField
        size='small' type='number'
        label='Max supply'
        inputProps={{ min: '0' }}
        value={form.max_supply}
        onChange={(e) => setField('max_supply', e.target.value)}
        placeholder='0 for unlimited'
        fullWidth
      />
    </Stack>
  );
}
